import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  welcomeToCE: {
    id: 'welcomeToCE',
    defaultMessage: 'Welcome to Control.Events',
  },
  welcomeText: {
    id: 'welcomeText',
    defaultMessage:
      'You have been registered new workspace and now you can invite your members!',
  },
  removeChannel: {
    id: 'removeChannel',
    defaultMessage: 'Delete channel:',
  },
  removeChannelInfo: {
    id: 'removeChannelInfo',
    defaultMessage:
      'All data that was imported from this channel will be permanently deleted without restore. Are you sure?',
  },
  removeAccount: {
    id: 'removeAccount',
    defaultMessage: 'Delete workspace:',
  },
  removeAccountInfo: {
    id: 'removeAccountInfo',
    defaultMessage:
      'All data from this workspace will be permanently deleted without restore. Are you sure?',
  },
  expiredSession: {
    id: 'expiredSession',
    defaultMessage: 'Session expiration',
  },
  expiredSessionInfo: {
    id: 'expiredSessionInfo',
    defaultMessage: 'Your session has been expired. Please restart session.',
  },
  newVersion: {
    id: 'newVersion',
    defaultMessage: 'New control version',
  },
  newVersionInfo: {
    id: 'newVersionInfo',
    defaultMessage:
      'New version {tag} of the Control.Events has been released!!! 🎉🎉🎉',
  },
  removeActors: {
    id: 'removeActors',
    defaultMessage: 'Delete actors',
  },
  cantDeleteActors: {
    id: 'cantDeleteActors',
    defaultMessage: "You can't delete these items",
  },
  removeActorsLinks: {
    id: 'removeActorsLinks',
    defaultMessage: 'Delete selected actors and links',
  },
  removeLayer: {
    id: 'removeLayer',
    defaultMessage: 'Delete layer',
  },
  removeLayers: {
    id: 'removeLayers',
    defaultMessage: 'Delete selected layers',
  },
  removeActorsGroup: {
    id: 'removeActorsGroup',
    defaultMessage: 'Delete group of actors',
  },
  removeLayerConfirm: {
    id: 'removeLayerConfirm',
    defaultMessage:
      "Are you sure you want to delete layer? You can't undo this action.",
  },
  removeActorsConfirm: {
    id: 'removeActorsConfirm',
    defaultMessage:
      "Are you sure you want to delete {count} selected items? You can't undo this action.",
  },
  removeActorConfirm: {
    id: 'removeActorConfirm',
    defaultMessage:
      "Are you sure you want to delete selected item? You can't undo this action.",
  },
  scriptDetails: {
    id: 'scriptDetails',
    defaultMessage: 'Script details',
  },
  removeScriptActor: {
    id: 'removeScriptActor',
    defaultMessage: 'Delete script',
  },
  removeGraph: {
    id: 'removeGraph',
    defaultMessage: 'Delete graph',
  },
  removeGraphInfo: {
    id: 'removeGraphInfo',
    defaultMessage: "You can't undo this action. Delete graph?",
  },
  removeLayerFromGraph: {
    id: 'removeLayerFromGraph',
    defaultMessage: 'Delete layer from graph',
  },
  removeLayerFromGraphInfo: {
    id: 'removeLayerFromGraphInfo',
    defaultMessage:
      'This layer will be removed only from this graph. Delete layer?',
  },
  deployScript: {
    id: 'deployScript',
    defaultMessage: 'Deploy changes',
  },
  deployScriptInfo: {
    id: 'deployScriptInfo',
    defaultMessage:
      'Are you sure you want to deploy all changes to Production? This action is irreversible. ',
  },
  removeTemplate: {
    id: 'removeTemplate',
    defaultMessage: 'Delete template',
  },
  removeTemplateConfirm: {
    id: 'removeTemplateConfirm',
    defaultMessage:
      "Are you sure you want to delete template? You can't undo this action.",
  },
  removeScript: {
    id: 'removeScript',
    defaultMessage: 'Delete script',
  },
  removeScriptInfo: {
    id: 'removeScriptInfo',
    defaultMessage: "You can't undo this action. Delete script?",
  },
  delOtherItems: {
    id: 'delOtherItems',
    defaultMessage: 'Delete without these items',
  },
  delFromLayer: {
    id: 'delFromLayer',
    defaultMessage: 'Delete from the layer',
  },
  actorWasRemoved: {
    id: 'actorWasRemoved',
    defaultMessage: 'Actor has been removed',
  },
  actorWasRemovedInfo: {
    id: 'actorWasRemovedInfo',
    defaultMessage: ' ',
  },
});

export default { ...globalIntl, ...m };
